import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: remove this component in Currency v2
import React from 'react';
import classNames from 'classnames';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import classes from '@nerdwallet/base-styles/classes';
import styles from './LegacyBox.module.less';
var flexColumnValues = ['auto', 0, 1, 2, 3, 4];
var wideFlexColumnValues = ['auto', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
var justifyFlexValues = ['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly', 'start'];
var wrapValues = ['wrap', 'nowrap'];
var noGutterValues = ['left', 'right', 'both'];
// Default styles and properties
var defaultBoxStyles = {
  columns: 'auto',
  direction: 'row',
  noGutter: undefined,
  justify: 'space-between',
  wrap: 'wrap'
};
/**
 * Generate styles based on the Grid System constraints
 * around breakpoint sizes. Include flexbox, gutter, and
 * margin styles based on columns and breakpoint size.
 */

var getBreakpointStyles = function getBreakpointStyles(breakpoint, options) {
  if (!options) return null;

  var _defaultBoxStyles$opt = _objectSpread(_objectSpread({}, defaultBoxStyles), options),
      columns = _defaultBoxStyles$opt.columns,
      direction = _defaultBoxStyles$opt.direction,
      noGutter = _defaultBoxStyles$opt.noGutter,
      justify = _defaultBoxStyles$opt.justify,
      wrap = _defaultBoxStyles$opt.wrap;

  var boxStyles = [classNames(styles["col-".concat(columns, "-").concat(breakpoint)], styles["flex-direction-".concat(direction, "-").concat(breakpoint)], styles["flex-wrap-".concat(wrap, "-").concat(breakpoint)], styles["justify-content-".concat(justify, "-").concat(breakpoint)])]; // Enable consumers to opt out of the default gutters that are
  // applied to all Boxes.

  var gutters = {
    left: true,
    right: true
  };

  if (noGutter === 'left') {
    gutters.left = false;
  } else if (noGutter === 'right') {
    gutters.right = false;
  } else if (noGutter === 'both') {
    gutters.left = false;
    gutters.right = false;
  }

  if (gutters.left) {
    boxStyles.push(styles["gutter-left-".concat(breakpoint)]);
  }

  if (gutters.right) {
    boxStyles.push(styles["gutter-right-".concat(breakpoint)]);
  }

  return boxStyles;
};
/**
 * Atomic alignment component. Internally knows about the NDS breakpoint. Used
 * to implement component and page level layout around a consistent grid system.
 */


export var LegacyBox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      className = props.className,
      _props$notWide = props.notWide,
      notWide = _props$notWide === void 0 ? defaultBoxStyles : _props$notWide,
      _props$wide = props.wide,
      wide = _props$wide === void 0 ? defaultBoxStyles : _props$wide,
      otherProps = _objectWithoutProperties(props, ["children", "component", "className", "notWide", "wide"]); // Apply grid system specific styles as well as custom style. Some
  // rules should be applied to every Box by default, regardless of breakpoint.


  var boxStyles = classes('display-flex', 'max-width-100');
  var notWideStyles = getBreakpointStyles('not-wide', notWide);
  var wideStyles = getBreakpointStyles('wide', wide);
  var gridStyles = classNames(boxStyles, notWideStyles, wideStyles, className);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: gridStyles,
    ref: ref
  }, otherProps), children);
});
LegacyBox.displayName = 'LegacyBox';
/**
 * See CenteredContainer alongside the other layout components
 * in @nerdwallet/react-layout.
 *
 * @deprecated
 */

export var BoxContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      notWide = props.notWide,
      wide = props.wide,
      otherProps = _objectWithoutProperties(props, ["children", "notWide", "wide"]);

  useDeprecatedComponentWarning({
    component: 'BoxContainer',
    version: '4.1.3',
    migration: 'See @nerdwallet/react-layout for <CenteredContainer> and other layout components.'
  });
  return /*#__PURE__*/React.createElement(LegacyBox, _extends({
    notWide: _objectSpread({
      noGutter: 'both'
    }, notWide),
    wide: _objectSpread({
      noGutter: 'both'
    }, wide)
  }, otherProps, {
    className: classNames(classes('max-width-container', 'margin-horizontal-auto', 'padding-horizontal-3', 'padding-horizontal-5--wide'), otherProps.className, styles['box-container']),
    ref: ref
  }), children);
});
BoxContainer.displayName = 'BoxContainer';